export const WARNING_SECONDS = 240;
